import { Component, HostListener, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from '../../../services/common.service';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject, Document_Upload_File, REGCONFIG_CONTROL, REGCONFIG_CONTROL_ANSWER, REGCONFIG_CONTROL_RESPONSE, dropdownsource } from 'src/app/models/common';
import { chooseOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-ist-registrations-view-modal',
  templateUrl: './ist-registrations-view-modal.component.html',
  styleUrls: ['./ist-registrations-view-modal.component.scss']
})
export class IstRegistrationsViewModalComponent implements OnInit {
  @Input() public Content: any;

  orgCode: string;
  orgId: string;
  userType: string;
  heading: string;
  action: Subject<any> = new Subject();
  headin: string;
  recState: boolean;
  formFields;
  chooseoptions = chooseOptionsConstant;
  generalInformationForm = new UntypedFormGroup({});
  recordstatus: string = "New";
  public controlsList: REGCONFIG_CONTROL[] = [];
  advanceSearch;
  selectedRow;
  tempdropsource: dropdownsource;
  sourceitems: dropdownsource[] = [];
  content: any;
  screenid: string;
  selectColumns: number = 4;
  screencode: string;
  ScreenContextCode: string = "";
  errormsg: string = "";
  dynomessage: string = "";
  validationMessage: string = "";
  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year: number = this.myDate.getFullYear() + 25;
  timeout: any;
  IsFormToched: boolean = false;
  IsBlocked: boolean = false;
  permission: string = "";
  tooltipValue: any;
  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public commonService: CommonService,
    public datepipe: DatePipe,
  ) {
  }
  RegistrationData: any;

  ngOnInit() {
    this.orgCode = this.Content.content.ORGCODE;
    this.orgId = this.Content.content.ORGID;
    this.userType = this.Content.content.USERTYPE;
    if (this.Content.heading === 'View' || this.Content.heading === 'Edit') {
      this.getScreensControlslistEdit();
      this.permission = 'view';
    }
    else {
      this.getScreensControlslist();
      this.permission = 'new';
    }


  }

  getScreensControlslist() {
    this.heading = "New";
    let ModuleId = "2";
    this.summaryService.GetregistrationProgram('api/appuser/GetregistrationProgram?ModuleId=' + ModuleId + "&orgId=" + this.orgId).subscribe(summary => {
      this.controlsList = summary;
      if (this.controlsList != null && this.controlsList.length > 0) {
        for (var i = 0; i < this.controlsList.length; i++) {
          this.controlsList[i].ControlValue = "";
          this.controlsList[i].SourceItems = [];
          if (this.controlsList[i].CONTROL == "4" || this.controlsList[i].CONTROL == "6" || this.controlsList[i].CONTROL == "7" || this.controlsList[i].CONTROL == "10") {
            var optionvalues = this.controlsList[i].GROUP_VALUES_LIST;
            var options = optionvalues;
            this.sourceitems = [];
            if (options != null && options != undefined && options.length > 0) {
              for (var iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt]["label"];
                  sourceitems.value = options[iOpt]["value"];
                  this.sourceitems.push(sourceitems);
                }
              }
              if (this.controlsList[i].CONTROL == "4") {
                let tempList = [];
                let sourceitems1 = new dropdownsource();
                sourceitems1.label = "Select";
                sourceitems1.value = "";
                tempList.push(sourceitems1);
                this.sourceitems = tempList.concat(this.sourceitems);
              }
              this.controlsList[i].SourceItems = this.sourceitems;
            }
          }
          else if (this.controlsList[i].CONTROL == "5") {
            const now = new Date();
            let formd = "";
            formd = this.datepipe.transform(new Date(), 'dd-MMM-yyyy');
            this.controlsList[i].ControlValue = null;           
          }
          else {
            this.controlsList[i].ControlValue = "";
          }
        }
      }
    });
  }

  public validateControlsMsgs(): string {
    this.validationMessage = "";
    if (this.controlsList != null && this.controlsList.length > 0) {
      for (var i = 0; i < this.controlsList.length; i++) {
        $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-untouched ng-valid");
        $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-pristine ng-invalid ng-touched validate-error");

        if (this.controlsList[i].CONTROL == "6") {
          let seletedItem = "";
          for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
            if (this.controlsList[i].SourceItems[c].Checked == true) {
              if (seletedItem == "")
                seletedItem = this.controlsList[i].SourceItems[c].value;
              else
                seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
            }
          }
          this.controlsList[i].ControlValue = seletedItem;
          if (this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
        }
        else if (this.controlsList[i].CONTROL == "10" && this.controlsList[i].IS_MANDATORY) {
          let SelectedValues = this.controlsList[i].ControlValue;
          if (SelectedValues == null || SelectedValues == undefined || SelectedValues == "") {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");

          }
        }
        else if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {

          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");

        }
        else if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined)) {
          let tempVal = this.controlsList[i].ControlValue.trim();
          if (tempVal == "") {
            var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
            this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
        }
        else if (this.controlsList[i].CONTROL == "4" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "5" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          var controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "7" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) // 
        {
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
          $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
        }
        else if (this.controlsList[i].CONTROL == "8" && this.controlsList[i].IS_MANDATORY) {

          if (this.controlsList[i].UploadFiles == null || this.controlsList[i].UploadFiles == undefined || this.controlsList[i].UploadFiles.length == 0) {
            this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
            $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
          }
          else if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined && this.controlsList[i].UploadFiles.length > 0) {
            let fileexits = this.controlsList[i].UploadFiles.filter((f) => {
              return f.Status != 'Delete'
            })[0];
            if (fileexits == undefined || fileexits == null) {
              this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
            }
          }

        }
        if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].IS_MANDATORY && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined) {
          this.controlsList[i].ControlValue = this.controlsList[i].ControlValue.trim();
          if (this.controlsList[i].FIELD_CODE == "EMAIL" && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue != "") {
            let isvalid = this.commonService.validateEmail(this.controlsList[i].ControlValue);
            if (!isvalid) {
              this.validationMessage += "Please enter valid " + this.controlsList[i].LABEL + "<br/>";
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");

            }
          }

          if (this.controlsList[i].FIELD_CODE == "WEBSITE" && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue != "") {
            const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
            if (!this.controlsList[i].ControlValue.match(website)) {
              this.validationMessage += "Please enter valid " + this.controlsList[i].LABEL + "<br/>";
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).addClass("ng-pristine ng-invalid ng-touched validate-error");
              $("#dynmcId" + this.controlsList[i].SERIAL_NO).removeClass("ng-untouched ng-valid");
            }
          }
        }
      }
    }
    return this.validationMessage;
  }
  isDateModified: boolean = false;

  Full_Date: DateObject;

  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }


  Registration() {
    this.errormsg = "";
    var errormsg = this.validateControlsMsgs();
    let formData1 = new FormData();
    let uploadData = new FormData();
    if (errormsg.length == 0) {
      if (this.controlsList != null && this.controlsList.length > 0) {
        for (var i = 0; i < this.controlsList.length; i++) {

          if (this.controlsList[i].CONTROL == "6") {
            let seletedItem = "";
            for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
              if (this.controlsList[i].SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = this.controlsList[i].SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
              }
            }
            this.controlsList[i].ANSWER = seletedItem;
          }
          else if (this.controlsList[i].CONTROL == "8") {
            if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined) {
              for (let j = 0; j < this.controlsList[i].UploadFiles.length; j++) {
                if (this.controlsList[i].UploadFiles[j].Status == "Add") {
                  uploadData.append(this.controlsList[i].UploadFiles[j].ID, this.controlsList[i].UploadFiles[j].File);
                }
              }
              this.controlsList[i].UploadFiles = this.controlsList[i].UploadFiles;
            }
          }
          else if (this.controlsList[i].CONTROL == "10") {
            let SelectedValues = this.controlsList[i].ControlValue;
            if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
              
              if($.isArray(SelectedValues))
              this.controlsList[i].ControlValue = SelectedValues.join(",");
            }
            else {
              this.controlsList[i].ControlValue = "";
            }
            this.controlsList[i].SUBFIELDNAME = "";
          }
          else if (this.controlsList[i].CONTROL == "5") {
            let controlanswer = this.controlsList[i].ControlValue;
            if (controlanswer != null && controlanswer != controlanswer != undefined) {
              let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
              this.controlsList[i].ANSWER = formd;
            }
            else {
              this.controlsList[i].ANSWER = controlanswer;
            }
          }

        }

        uploadData.append("ScreenData", JSON.stringify(this.controlsList));
        this.summaryService.FilesInsert("api/appuser/insertistregistration", uploadData).subscribe((result) => {
          if (result != null && result.Status == 0) {
            this.commonService.SuccessBanner(result.Message);
            this.modalRef.close();
          }
          else {
            for (var i = 0; i < this.controlsList.length; i++) {          
              if (this.controlsList[i].CONTROL == "10") {
                if (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue.length > 0) {
                   this.controlsList[i].ControlValue = this.controlsList[i].ControlValue.split(",");
                }   
              }
            }
            this.commonService.ValidationBanner(result.Message);
          }
        });

      }
    }
    else {
      this.commonService.ValidationBanner(errormsg);
    }
  }

  IsRadioChecked(question: any): void {
    let isError: boolean = false;

    if (question.ControlValue == "" && question.Property.Required) {
      question.Property.TempMessage = question.Property.Message;
      question.Property.ShowMessage = true;
    }
    else {
      question.Property.TempMessage = "";
      question.Property.ShowMessage = false;
    }
  }

  IsCheckBoxChecked(propery: any, question: any): void {
    let isError: boolean = false;
    if (propery != undefined && propery != null) {
      for (var iOpt = 0; iOpt < propery.Options.length; iOpt++) {
        if (propery.Options[iOpt].Checked != null && propery.Options[iOpt].Checked) {
          propery.TempMessage = "";
          propery.ShowMessage = false;
          isError = true;
          break;
        }
      }
    }

    if (!isError) {
      propery.TempMessage = propery.Message;
      propery.ShowMessage = true;
    }
    else {
      propery.TempMessage = "";
      propery.ShowMessage = false;
    }
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  DeleteUpload(file, ques: REGCONFIG_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
   
    }
  }

  OpenFile(item: Document_Upload_File): void {
    
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    
  }
 

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }
  uploadchange(event, ques: REGCONFIG_CONTROL): void {
    this.IsFormToched = true;
    //let DiffirentFormates = false;
let Isexe = false;
let Is5oMB = false;

    let samefileName = false;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let filename = event.target.files[i].name;
      var ext = filename.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;
      let IsValid = true;

      if (filename != null && (ext == 'exe')) {
        Isexe = true;        
      }
      else if (filename != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }

      if (IsValid) {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = this.CreateGuid();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if (hasValue.length > 0) {
          samefileName = true;
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");

        } else {
          if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          }
          else {
            ques.UploadFiles = [];
            ques.UploadFiles.push(uploadFile);
          }
        }

      }

    }
    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }

    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }

    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else {

    }
  }

  isAllowedExtensionFile(Filename)
  {
    return this.commonService.isAllowedExtension(Filename);
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControls= question.ControlValue;
      if(selectedControls != "" && selectedControls != undefined && selectedControls != null)
        {
          let controlLabel= question.SourceItems.filter((item)=>{
            return  selectedControls.indexOf(item.value)>-1;
           })
           let labellist=[];
           controlLabel.forEach((item)=>{
             labellist.push(item.label);
           });
           this.tooltipValue =labellist.join(",");
        }
        else
        {
          this.tooltipValue = "";
        }
        
      }, 200);
  }

  singleonChange($event) {
    this.IsFormToched = true;
  }
  getScreensControlslistEdit() {

    this.commonService.getRegistratinConfiguredFiledsData(this.Content.content.id, "IST").subscribe(summary => {
      this.controlsList = summary["Data"];
      this.IsBlocked = summary["TransactionCode"] == "0" ? true : false;

      if (this.controlsList != null && this.controlsList.length > 0) {
        // this.screenid = this.screencontrols.ID;
        for (var i = 0; i < this.controlsList.length; i++) {
          //  this.controlsList[i].ControlValue = "";
          this.controlsList[i].SourceItems = [];
          if (this.controlsList[i].CONTROL == "4" || this.controlsList[i].CONTROL == "6" || this.controlsList[i].CONTROL == "7" || this.controlsList[i].CONTROL == "10") {
            // var optionvalues = this.screencontrols.SCREEN_CONTROL[i].GROUP_VALUES;           
            var optionvalues = this.controlsList[i].GROUP_VALUES_LIST;

            var options = optionvalues;
            this.sourceitems = [];
            // var options = optionvalues.split(',');
            if (options != null && options != undefined && options.length > 0) {
              for (var iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt]["label"];
                  sourceitems.value = options[iOpt]["value"];
                  this.sourceitems.push(sourceitems);
                }
              }
              if (this.controlsList[i].CONTROL == "10") {
                let selectedlist = [];
                this.controlsList[i].ControlValue.split(",").forEach((item) => {
                  selectedlist.push(item);
                });
                this.controlsList[i].ControlValue = selectedlist;
              }

              if (this.controlsList[i].CONTROL == "6") {

                if(this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue.split(',').length > 1){
                  this.controlsList[i].ControlValue.split(",").forEach((item) => {
                    let source = this.sourceitems.find(x=> x.value == item);
                    source.Checked = true;                                    
                  });
                } else{
                  if(this.controlsList[i].ControlValue != null){
                    let source = this.sourceitems.find(x=> x.value == this.controlsList[i].ControlValue);
                    source.Checked = true; 
                  }                    
                }             
              }

              if (this.controlsList[i].CONTROL == "4") {
                let tempList = [];
                let sourceitems1 = new dropdownsource();
                sourceitems1.label = "Select";
                sourceitems1.value = "";
                tempList.push(sourceitems1);
                this.sourceitems = tempList.concat(this.sourceitems);
              }
              this.controlsList[i].SourceItems = this.sourceitems;
            }
          }
          else if (this.controlsList[i].CONTROL == "5") {
            this.controlsList[i].ControlValue= new Date(this.controlsList[i].ControlValue);
            let controlanswer = new Date(this.controlsList[i].ControlValue);
            if (controlanswer != null && controlanswer != controlanswer != undefined &&  this.controlsList[i].DATEFORMATE == 'DD-MMM-YYYY') {
              let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
              this.controlsList[i].ANSWER = formd;
            } 
          }
          else {
            this.controlsList[i].ControlValue = this.controlsList[i].ControlValue;
          }
        }
      }
    });
  }

  BlockUser() {

    let formData1 = new Object();
    formData1["ID"] = this.Content.content.id;
    formData1["RECORD_STATE"] = this.IsBlocked == true ? 0 : 1;
    formData1["MODULE"] = this.Content.content.Module;
    this.summaryService.updateUser("api/ISTRegistration/updateUser", formData1).subscribe((result: any) => {
      if ((result.Status == 0)) {
        this.commonService.SuccessBanner("Registration Details updated successfully");
        this.modalRef.close("Yes");
      } else {
        this.commonService.ValidationBanner(result.Message);
      }


    });
  }
}
